import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex';
import SidebarItem from "./SidebarItem";
import _variables from '@/styles/variables.scss';
import elementResizeDetectorMaker from 'element-resize-detector';
export default {
  components: {
    SidebarItem: SidebarItem
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters(['permission_routes', 'sidebar', 'menuList'])), mapState({
    slideClass: function slideClass(state) {
      return state.settings.slideClass;
    }
  })), {}, {
    classObj: function classObj() {
      return {
        // [this.slideClass]: true
      };
    },
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
        path = route.path;
      // if (meta.activeMenu) {
      //   return meta.activeMenu
      // }
      return path;
    },
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables: function variables() {
      return _variables;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  }),
  data: function data() {
    return {
      activeName: '',
      list: []
    };
  },
  created: function created() {
    var _this2 = this;
    var _this = this;
    this.$nextTick(function () {
      // 监听页面宽度变化
      var erd = elementResizeDetectorMaker({
        strategy: "scroll"
      });
      erd.listenTo(document.getElementById('topMenu'), function (element) {
        var width = element.offsetWidth;
        var newList = [];
        var moreItem = {
          path: "/menuMore",
          newChildren: [],
          fullName: '更多 ...',
          vueName: 'moreMenu',
          icon: ''
        };
        var number = Math.floor(width / 116);
        var length = _this.menuList.length;
        if (number >= length) return _this.list = _this.menuList;
        for (var i = 0; i < length; i++) {
          var item = _this.menuList[i];
          if (i < number - 1) {
            newList.push(item);
          } else {
            moreItem.newChildren.push(item);
          }
        }
        if (moreItem.newChildren.length) newList.push(moreItem);
        _this.list = newList;
      });
      _this2.$nextTick(function () {
        _this2.setDefault();
      });
    });
  },
  methods: {
    setDefault: function setDefault() {
      var _this3 = this;
      var currPath = this.$route.path;
      var modelId = this.$route.meta.modelId || '';
      if (!modelId) return;
      var _loop = function _loop() {
        var e = _this3.menuList[i];
        var boo = false;
        var _loop2 = function loop(data) {
          if (modelId === data.id) {
            boo = true;
            _this3.activeName = e.path;
            if (e.type === 1) _this3.$store.commit('user/SET_LEFTMENULIST', e.children || []);
            return;
          }
          if (data.children && Array.isArray(data.children) && data.children.length) {
            for (var j = 0; j < data.children.length; j++) {
              _loop2(data.children[j]);
            }
          }
        };
        _loop2(e);
        if (boo) return 1; // break
      };
      for (var i = 0; i < this.menuList.length; i++) {
        if (_loop()) break;
      }
    }
  }
};